import React from 'react';
import { Dialog, FormGrid, LoadingIndicator, SearchField } from '../../../toolympus/components/primitives';
import { FullSearchData, IFullSearchResult, itemLink, RecordTypeLabelMap } from './useFullSearch';
import { useHistory } from 'react-router-dom';
import { TableForFields } from '../../../toolympus/components/schemed';

interface Props {
  data: FullSearchData;
}



export const FullSearchDialog = (props: Props) => {
  const { form, items } = props.data;
  const history = useHistory();

  if(!form.item) {
    return null;
  }

  // Helper to handle navigation and closing the dialog
  const handleRowClick = (item: IFullSearchResult) => {
    const link = itemLink(item, "content");
    if (link) {
      form.cancel();
      history.push(link);
    }
  };

  return (
    <Dialog
      dialogTitle="Search"
      maxWidth="md"
      noFullscreen
      {...form.dialog}
    >
      <FormGrid columns="1fr" noMargin>
        <SearchField
          filter={form.item.filter}
          setFilter={v => form.update({ filter: v })}
          autoFocus
          noButton
          fullWidth
          doSearch={() => {
            if(items.data.length === 1) {
              handleRowClick(items.data[0]);
            }
          }}
        />
      </FormGrid>

      {/* Results Container */}
      <div style={{ marginTop: '20px', minHeight: '300px', display: 'flex', flexDirection: 'column' }}>
        
        {items.isLoading && (
          <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            <LoadingIndicator />
          </div>
        )}

        {!items.isLoading && items.data.length === 0 && form.item.filter && (
          <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            No results found.
          </div>
        )}

        {!items.isLoading && items.data.length > 0 && (
          <>
            <div style={{ flexGrow: 1, overflowX: 'auto' }}>
              <TableForFields
                data={items.data}
                fields={[
                  ["record_type", { label: "Type" }],
                  ["title", { label: "Title" }],
                  ["_id", { label: "ID" }],
                ]}
                schema={{}}
                fieldElement={f => {
                  switch(f) {
                    case "record_type":
                      return r => <span>{RecordTypeLabelMap[r.record_type] || ""}</span>
                  }
                }}
                onRowClick={r => handleRowClick(r)}
                rowStyle={r => ({ cursor: "pointer" })}
                />
            </div>

            {/* Pagination Controls */}
            {items.paging && items.paging.total_pages > 1 && (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginTop: '16px',
                paddingTop: '16px',
                borderTop: '1px solid #eee' 
              }}>
                <div style={{ fontSize: '14px', color: '#666' }}>
                  Showing {items.paging.start + 1} - {Math.min(items.paging.start + items.paging.page_size, items.paging.total_rows)} of {items.paging.total_rows}
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <button 
                    onClick={() => items.goPrevPage()} 
                    disabled={items.paging.page_number <= 1}
                    style={{ padding: '6px 12px', cursor: items.paging.page_number <= 1 ? 'not-allowed' : 'pointer' }}
                  >
                    Previous
                  </button>
                  
                  <span style={{ fontSize: '14px' }}>
                    Page {items.paging.page_number} of {items.paging.total_pages}
                  </span>
                  
                  <button 
                    onClick={() => items.goNextPage()} 
                    disabled={items.paging.page_number >= items.paging.total_pages}
                    style={{ padding: '6px 12px', cursor: items.paging.page_number >= items.paging.total_pages ? 'not-allowed' : 'pointer' }}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Dialog>
  );
}
